import axios from "axios";
import { UI } from "./lang";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export function errorMessage(err, lang = "de") {
  const d = err?.response?.data?.detail;
  const t = UI[lang];
  if (!err?.response) return t.noConnection;
  if (typeof d === "string") return d;
  if (d && typeof d.message === "string") return d.message;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ");
  return t.genericError;
}

export function fieldErrors(err) {
  const f = err?.response?.data?.detail?.fields;
  return f && typeof f === "object" ? f : {};
}
